import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import type { ComparedCollege } from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

import { Box, Chip, SxProps, Theme, Typography } from '@mui/material';

import { factorLabel } from '../compare.util';

const STRINGS = appStrings.modules.myColleges.compare;

export const TopMatchBadge = ({ size = 'sm' }: Readonly<{ size?: 'sm' | 'md' }>) => (
  <Chip
    variant="pill"
    size={size}
    type="leading"
    label={STRINGS.topMatch}
    icon={<Box component="span" sx={dotSx} />}
    sx={topMatchSx}
  />
);

export const BestForWatch = ({ college }: Readonly<{ college: ComparedCollege }>) => (
  <Box sx={notesSx}>
    {college.best_at && <Note label={STRINGS.bestFor} factor={factorLabel(college.best_at)} />}
    {college.watch && <Note label={STRINGS.watch} factor={factorLabel(college.watch)} />}
  </Box>
);

const Note = ({ label, factor }: Readonly<{ label: string; factor: string }>) => (
  <Box sx={noteSx}>
    <Chip variant="badge" size="sm" label={label} sx={noteBadgeSx} />
    <Typography variant="text-sm-regular" sx={mutedSx}>
      {factor}
    </Typography>
  </Box>
);

const topMatchSx: SxProps<Theme> = ({ backrs }) => ({
  paddingBlock: backrs.spacing['spacing-xxs'],
  paddingInline: backrs.spacing['spacing-md'],
  borderColor: backrs.colors['Brand/200'],
  backgroundColor: backrs.colors['Brand/50'],
  color: backrs.colors['Brand/700'],
  '& .MuiChip-icon': { margin: 0 },
});

const dotSx: SxProps<Theme> = ({ backrs }) => ({
  width: backrs.spacing['spacing-sm'],
  height: backrs.spacing['spacing-sm'],
  borderRadius: backrs.radius['radius-full'],
  backgroundColor: backrs.colors['Brand/500'],
});

const notesSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-sm'],
});

const noteSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-sm'],
});

const noteBadgeSx: SxProps<Theme> = ({ backrs }) => ({
  borderColor: backrs.colors['Colors/Border/border-primary'],
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  color: backrs.colors['Colors/Text/text-secondary'],
});

const mutedSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
